export const presetSizes = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96,
};
//# sourceMappingURL=constants.js.map